export const bhpColor = '#e65400';


export const bhpButtonSx = {

    backgroundColor: bhpColor,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#cc4700'
    },
    "&.Mui-disabled": {
        background: "#eaeaea",
        color: "#c0c0c0"
    }

};


export const dataGridSx = {

    cursor: 'pointer',
    '.MuiDataGrid-columnHeaderTitle': { 
        fontWeight: 'bold !important',
        overflow: 'visible !important'
    },

    '.MuiDataGrid-cell:focus': {
        outline: 'none'
    }

};

